import { isValueExist } from '@/utils/utils';

import {
    MULTIPLE_VALUE_AVAILABLE_FIELDS,
    OUTER_CONDITIONS_PATH,
} from '@/components/Dashboard/common/Filter/const';
import { FIELD_OPTIONS } from '@/components/Dashboard/common/SearchBar/filters/const';
import { FILTER_KEYS } from '@/utils/consts';

const { ID } = FILTER_KEYS;

export const getOuterConditions = R.pathOr([], OUTER_CONDITIONS_PATH);

export const checkIsFullFilter = ({ field, operator, values = [] }) => {
    const firstValue = R.head(values);
    const valueExist = R.ifElse(
        (v) => R.equals('String', R.type(v)),
        R.trim,
        isValueExist
    )(firstValue);
    return field && operator && valueExist;
};

export const checkHasLevel = (field) =>
    R.pathSatisfies(isValueExist, [field, 'level'], FIELD_OPTIONS);

export const countFullFilters = (where) => {
    const outerConditions = getOuterConditions(where);

    return outerConditions.reduce(
        (acc, { conditions = [] }) =>
            acc + conditions.filter(checkIsFullFilter).length,
        0
    );
};

export const countFilters = (where) => {
    const outerConditions = getOuterConditions(where);

    return outerConditions.reduce(
        (acc, { conditions = [] }) => acc + conditions.length,
        0
    );
};

const makeSingleValueConditions = R.curryN(3, (field, level, values) => {
    return values.map((value) => ({
        operator: 'AND',
        conditions: [
            {
                field,
                level: field === ID ? level : undefined,
                values: [value],
                operator: 'IN',
                not: false,
            },
        ],
    }));
});
export const makeMultipleValueConditions = R.curryN(
    3,
    (field, level, values) => {
        return [
            {
                operator: 'AND',
                conditions: [
                    {
                        field,
                        level: field === ID ? level : undefined,
                        values,
                        operator: 'IN',
                        not: false,
                    },
                ],
            },
        ];
    }
);

export const makeWhereFormat = R.curryN(3, (field, level, values) => {
    const conditions = R.includes(field, MULTIPLE_VALUE_AVAILABLE_FIELDS)
        ? makeMultipleValueConditions(field, level, values)
        : makeSingleValueConditions(field, level, values);

    return [
        {
            operator: 'OR',
            conditions: conditions,
        },
    ];
});

export const makeGroupFiltersFormat = R.curryN(3, (field, level, values) => {
    const where = makeWhereFormat(field, level, values);
    return [{ groupId: 'marketing', where }];
});

export const countGroupFilters = (groupFilters = []) => {
    return groupFilters.length;
};
